import { render } from "./cfParametersComponent.vue?vue&type=template&id=08ec4f09&scoped=true"
import script from "./cfParametersComponent.vue?vue&type=script&lang=js"
export * from "./cfParametersComponent.vue?vue&type=script&lang=js"

import "./cfParametersComponent.vue?vue&type=style&index=0&id=08ec4f09&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ec4f09"]])

export default __exports__